import actionTypes from './type';
import Storage from '../../../storage';

export function signIn(userData) {
  return (dispatch) => {
    Storage.saveUser(userData)
      .then((user) => {
        dispatch(changeUser(user));
      })
      .catch((error) => {
        console.log('signIn -> error', error);
      });
  };
}

export function signOut() {
  return (dispatch) => {
    Storage.removeUser();
    dispatch(changeUser(null));
  };
}

export function appInitialized() {
  return changeAppInitializing(false);
}

export function appStartInitializing() {
  return changeAppInitializing(true);
}

export function updateUserInfo(userData) {
  return (dispatch) => {
    Storage.saveUser(userData)
      .then((user) => {
        dispatch(changeUser(user));
      })
      .catch((error) => {
        console.log('updateUserInfo -> error', error);
      });
  };
}

export function changeAppInitializing(initializing) {
  return { type: actionTypes.APP_INITIALIZING_CHANGED, initializing };
}

export function changeUser(user) {
  return { type: actionTypes.USER_CHANGED, user };
}

export function changeOpenSearch() {
  return { type: actionTypes.OPEN_SEARCH };
}
export function changeCloseSearch() {
  return { type: actionTypes.CLOSE_SEARCH };
}

export function pushDataSearch(payload) {
  return { type: actionTypes.PUSH_DATA_QUERY_SEARCH, payload };
}
export function clearDataSearch() {
  return { type: actionTypes.CLEAR_DATA_QUERY_SEARCH };
}

export function changeIsCountSearch(isCount = false) {
  return { type: actionTypes.IS_COUNT_SEARCH, isCount };
}
